let active = false;
let lastEmail = null;
let epoch = 0;
const listeners = new Set();
const accountListeners = new Set();

export function isSessionActive() {
    return active;
}

export function getSessionEpoch() {
    return epoch;
}

export function setSessionActive(next) {
    const value = Boolean(next);
    if (value === active) {
        return;
    }

    active = value;
    listeners.forEach((listener) => {
        try {
            listener(active);
        } catch (error) {
            console.error('[sessionActivity] listener error', error);
        }
    });
}

/**
 * Utente confermato da AuthController, oppure null se la sessione non c'è.
 * Lo stesso account che torna non resetta la pagina.
 * Un account diverso la riporta al primo accesso.
 */
export function setSessionUser(user) {
    const email = user && user.email ? String(user.email) : '';
    if (!email) {
        setSessionActive(false);
        return;
    }

    const accountChanged = Boolean(lastEmail) && lastEmail !== email;
    lastEmail = email;

    if (accountChanged) {
        epoch += 1;
        accountListeners.forEach((listener) => {
            try {
                listener(email);
            } catch (error) {
                console.error('[sessionActivity] account listener error', error);
            }
        });
    }

    setSessionActive(true);
}

export function subscribeAccountChange(listener) {
    accountListeners.add(listener);
    return () => {
        accountListeners.delete(listener);
    };
}

export function subscribeSessionActive(listener) {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}

/**
 * Ferma il download HLS senza distruggere il player, così al ritorno
 * della sessione il video riparte dallo stesso elemento.
 */
export function attachSessionPlayback(video, getHls) {
    if (!video) {
        return () => {};
    }

    const apply = (isActive) => {
        const hls = typeof getHls === 'function' ? getHls() : null;

        if (!isActive) {
            if (hls && typeof hls.stopLoad === 'function') {
                hls.stopLoad();
            }
            video.pause();
            return;
        }

        if (hls && typeof hls.startLoad === 'function') {
            hls.startLoad(-1);
        }

        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
        }
    };

    const unsubscribe = subscribeSessionActive(apply);
    if (!active) {
        apply(false);
    }

    return unsubscribe;
}
